import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite/no-important';
import Text from './Text';
import {
  WHITE,
  CENTER,
  TRANSPARENT,
  BASE_SPACING,
  ALTO,
  LOCHMARA,
  DOVE_GRAY,
} from '../styles';
import Button, { TYPES } from './Button';

const s = StyleSheet.create({
  root: {
    position: 'relative',
    width: 'calc(100% - 20px)',
    appearance: 'none',
    borderWidth: 0,
    outline: 0,
    padding: 0,
    backgroundColor: TRANSPARENT,
  },
  participant: {
    display: 'flex',
    alignItems: CENTER,
    marginBottom: 4,
    backgroundColor: WHITE,
    height: 40,
    paddingLeft: 12,
    fontSize: 14,
    borderRadius: 2,
    border: `1px solid ${ALTO}`,
  },
  participantLooser: {
    backgroundColor: TRANSPARENT,
  },
  edit: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    right: -BASE_SPACING,
  },
  winner: {
    color: LOCHMARA,
  },
  disabled: {
    backgroundColor: DOVE_GRAY,
    borderColor: DOVE_GRAY,
  },
  empty: {
    color: ALTO,
  },
  gap: {
    marginBottom: BASE_SPACING * 1.5,
  },
});

const Participant = ({ name, index, winner }) => (
  <div
    className={css(
      s.participant,
      !winner && s.participantLooser,
      winner && s.winner,
      !name && s.empty
    )}
  >
    <Text
      messageId={name || 'app.tree.node.participant'}
      variables={{ index }}
    />
  </div>
);

Participant.propTypes = {
  name: PropTypes.string,
  index: PropTypes.number,
  winner: PropTypes.bool,
};

const BracketNode = ({
  participants,
  index,
  initial,
  onClick,
  extraGap,
  video,
}) => {
  const disabled = !initial && participants.length !== 2;
  return (
    <button
      className={css(s.root, !!extraGap && s.gap)}
      onClick={onClick}
      disabled={disabled}
    >
      <Participant {...participants[0]} index={index + 1} />
      <Participant {...participants[1]} index={index + 2} />
      <Button
        messageId="app.tree.node.participant.edit"
        __className={[s.edit, disabled && s.disabled]}
        __type={TYPES.PRIMARY}
        component="div"
      />
    </button>
  );
};

BracketNode.propTypes = {
  id: PropTypes.number,
  initial: PropTypes.bool,
  index: PropTypes.number,
  participants: PropTypes.array,
  onClick: PropTypes.func,
  video: PropTypes.string,
  extraGap: PropTypes.bool,
};

export default BracketNode;
